import { ChangeDetectorRef, Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: "app-custom-place-modal",
    templateUrl: "./custom-place-modal.component.html",
    styleUrls: ["./custom-place-modal.component.scss"],
    standalone: false
})
export class CustomPlaceModalComponent {
  isShowDialogTitle: boolean = true;
  showAddToPublicPlace: boolean;
  polygon: any;
  polygonTitles: any;

  constructor(
    private dialogRef: MatDialogRef<CustomPlaceModalComponent>,
    private cd: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.showAddToPublicPlace = data?.showAddToPublicPlace;
    this.polygon = data?.polygon;
    this.polygonTitles = data?.polygonTitles;
  }

  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }

  onSelect(smsText) {
    this.dialogRef.close(smsText);
  }

  onClose() {
    this.dialogRef.close();
  }
}
